import { createPropsProvider } from "@kikoff/client-utils/src/react";
import ContainerButton from "@kikoff/components/src/v1/buttons/ContainerButton";
import { cls } from "@kikoff/utils/src/string";

import PageAlign, {
  PageAlignProps,
} from "@component/dashboard/offer/page_align";

import styles from "./page_layout.module.scss";

interface PageLayoutProps {
  className?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  propsFor?: {
    title?: React.ComponentProps<"div">;
    subtitle?: React.ComponentProps<"div">;
    pageAlign?: PageAlignProps;
  };
  onBack(): void;
  action?: React.ReactNode;
  children: React.ReactNode;
}

export default function PageLayout(_props: PageLayoutProps) {
  const {
    className,
    title,
    subtitle,
    onBack,
    propsFor = {},
    action,
    children,
  } = PageLayout.PropsProvider.useMerge(_props);

  return (
    <PageAlign {...propsFor.pageAlign} scroll>
      <div className={cls(styles["page-layout"], className)}>
        <div className={styles.top}>
          <ContainerButton fit onClick={onBack}>
            
          </ContainerButton>
          {action && <div>{action}</div>}
        </div>
        <header
          {...propsFor.title}
          className={cls("text:heading-3", propsFor.title?.className)}
        >
          {title}
        </header>
        {subtitle && <div {...propsFor.subtitle}>{subtitle}</div>}
        <div>{children}</div>
      </div>
    </PageAlign>
  );
}

PageLayout.PropsProvider = createPropsProvider<PageLayoutProps>("PageLayout");
